import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from '../data/translations';
import { ArrowRight, ArrowLeft } from 'lucide-react';

const BASE = "https://www.cobras.be/sites/default/files/styles/";

const DesignPage = () => {
  const { lang } = useLanguage();
  const { t, get } = useTranslation(lang);
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { window.scrollTo(0,0); setTimeout(()=>setLoaded(true),100); }, []);
  const p = t.designPage;

  return (
    <div className="min-h-screen" style={{background:'#0a0a0a'}}>
      <div className="fixed inset-0 opacity-30 pointer-events-none z-0" style={{backgroundImage:`url("data:image/svg+xml,%3Csvg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E")`,backgroundSize:'256px'}} />
      <div className="relative z-10">
        <div className="pt-28 md:pt-36 pb-8 px-8 md:px-16 lg:px-24">
          <button onClick={()=>navigate('/')} className="inline-flex items-center gap-2 text-gray-400 hover:text-white text-sm font-medium mb-8 transition-colors"><ArrowLeft size={16}/> {get(t.common.home)}</button>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-white uppercase tracking-tight italic" style={{opacity:loaded?1:0,transform:loaded?'translateY(0)':'translateY(30px)',transition:'all 0.8s cubic-bezier(0.16,1,0.3,1)'}}>{get(p.title)}</h1>
        </div>

        <div className="px-8 md:px-16 lg:px-24 pb-8">
          <p className="text-xl md:text-2xl font-bold text-white mb-8 max-w-3xl">{get(p.subtitle)}</p>
        </div>

        <div className="px-8 md:px-16 lg:px-24 mb-12 max-w-4xl">
          <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-6">{get(p.paragraph1)}</p>
        </div>

        {/* Diamond graphic + Image */}
        <div className="px-8 md:px-16 lg:px-24 mb-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <svg viewBox="0 0 300 60" className="w-full max-w-[280px] opacity-30 mb-8" fill="none" stroke="white" strokeWidth="1">
                <path d="M0,30 L30,0 L60,30 L30,60 Z" /><path d="M40,30 L70,0 L100,30 L70,60 Z" /><path d="M80,30 L110,0 L140,30 L110,60 Z" /><path d="M120,30 L150,0 L180,30 L150,60 Z" /><path d="M160,30 L190,0 L220,30 L190,60 Z" /><path d="M200,30 L230,0 L260,30 L230,60 Z" />
              </svg>
            </div>
            <div className="overflow-hidden rounded-sm">
              <img src={BASE+"text_media_small/public/uploads/images/cobras_website_18_vierkant_1.jpg"} alt="" className="w-full object-cover"/>
            </div>
          </div>
        </div>

        {/* Second section */}
        <div className="px-8 md:px-16 lg:px-24 mb-12">
          <p className="text-sm uppercase tracking-[0.15em] mb-2" style={{color:'#A855F7'}}>{get(p.thinkFirst)}</p>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-6">{get(p.orderTitle)}</h2>
          <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-8 max-w-3xl">{get(p.paragraph2)}</p>
        </div>

        {/* Full width image */}
        <div className="px-8 md:px-16 lg:px-24 mb-16">
          <img src={BASE+"lightbox/public/uploads/images/cobras_website_15.jpg"} alt="" className="w-full object-cover rounded-sm" style={{maxHeight:'60vh'}}/>
        </div>

        {/* Good prep note */}
        <div className="px-8 md:px-16 lg:px-24 py-8">
          <p className="text-xl font-bold text-white mb-6">{get(p.goodPrep)}</p>
        </div>

        {/* Navigation */}
        <div className="px-8 md:px-16 lg:px-24 py-8 flex flex-wrap gap-6">
          <button onClick={()=>navigate('/ambitiedocument')} className="inline-flex items-center gap-2 font-bold text-sm tracking-wider uppercase hover:gap-4 transition-all duration-300" style={{color:'#A855F7'}}>
            <ArrowLeft size={18}/> {get(p.toStep1)}
          </button>
          <button onClick={()=>navigate('/uitvoering')} className="inline-flex items-center gap-2 font-bold text-sm tracking-wider uppercase hover:gap-4 transition-all duration-300" style={{color:'#A855F7'}}>
            {get(p.toStep3)} <ArrowRight size={18}/>
          </button>
        </div>

        {/* CTA */}
        <div className="px-8 md:px-16 lg:px-24 py-16 text-center">
          <h2 className="text-3xl md:text-4xl font-black text-white italic mb-8">{get(t.common.curious)}</h2>
          <button onClick={()=>{ navigate('/contact'); window.scrollTo({top:0}); }} className="inline-flex items-center gap-3 border-2 text-white px-10 py-4 text-sm font-bold tracking-[0.2em] uppercase transition-all duration-500 group" style={{borderColor:'#A855F7'}} onMouseEnter={e=>e.currentTarget.style.backgroundColor='#A855F7'} onMouseLeave={e=>e.currentTarget.style.backgroundColor='transparent'}>
            {get(t.common.contactUs)} <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1"/>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DesignPage;
